import { Avatar, Dialog, DialogContent, DialogContentText, DialogTitle, List, ListItem, ListItemAvatar, ListItemText, useTheme } from '@mui/material'
import { capitalize } from 'lodash'
import { getLoginProviderConfig, LoginProvider } from '../../../config/firebase'

interface HelpDialogProps {
  isOpen: boolean
  userLoginProviderIds: string[]
  handleClose: () => void
  handleProvider: (provider: LoginProvider) => Promise<void>
}

export default function HelpDialog(props: HelpDialogProps) {
  const theme = useTheme()
  const { handleClose, handleProvider, isOpen = false, userLoginProviderIds } = props

  return (
    <Dialog onClose={handleClose} open={isOpen}>
      <DialogTitle>Having trouble signing in?</DialogTitle>
      <DialogContent>
        <DialogContentText>You&apos;ve recently signed in using the following methods, press any below to sign in instantly.</DialogContentText>
      </DialogContent>
      <List sx={{ pt: 0 }}>
        {userLoginProviderIds.map((providerId: string) => {
          const { LogoSvg, name, getProvider } = getLoginProviderConfig(providerId)
          const provider = getProvider()

          return (
            <ListItem button onClick={() => handleProvider(provider)} key={`recent-login-${providerId}`}>
              <ListItemAvatar>
                <Avatar sx={{ backgroundColor: theme.palette.customGrey[100] }}>
                  <LogoSvg width={32} height={32} />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={capitalize(name)} />
            </ListItem>
          )
        })}
      </List>
    </Dialog>
  )
}
